<template>
  <div>
    <section :key="page.title" v-for="(page, i) in pages">
      <template v-if="currentPage === i">
        <div class="page-intro">
          <HeaderWithIcon :title="page.title" />
        </div>
        <workplace-search
          :hasError="showError"
          @selected-employer="showError = false"
          v-if="page.showWorkplaceSearch"
        />
        <notification />
        <ValidationObserver ref="form">
          <form-component :page="page" @submit="incrementPage" />
        </ValidationObserver>
      </template>
    </section>
    <section class="form-controls">
      <button
        v-if="!isFromReview"
        role="button"
        class="btn btn--link"
        @click="goBack"
      >
        Back
      </button>
      <button role="button" class="btn btn--positive" @click="incrementPage">
        {{ isFromReview ? "Confirm" : "Next" }}
      </button>
    </section>
  </div>
</template>

<script>
import FormComponent from "@/components/FormComponent.vue";
import HeaderWithIcon from "@/components/HeaderWithIcon";
import WorkplaceSearch from "@/components/WorkplaceSearch";
import { WorkDetailsDefinition } from "@/definitions/section-definitions";
import { useMemberDetails } from "@/helpers/member-details";
import { studentCodes } from "@/helpers/membership";
import { useNotification } from "@/helpers/notification";
import { filterPages, goToPreviousPage } from "@/helpers/page";
import { nextStep } from "@/helpers/progress-helper";
import { useShowSpinner } from "@/helpers/showSpinner";
import { useWorkplaceSearch } from "@/helpers/workplace-search";
import { ref, watch } from "@vue/composition-api";
import { ValidationObserver } from "vee-validate";
import Notification from "@/components/Notification";

export default {
  components: {
    ValidationObserver,
    WorkplaceSearch,
    FormComponent,
    HeaderWithIcon,
    Notification,
  },
  props: {
    currentPage: { type: Number, default: 0 },
  },
  setup(props, ctx) {
    const showError = ref(false);
    const { isActivating, ...memberDetails } = useMemberDetails();
    const { showNotification } = useNotification();
    const { setShowSpinner } = useShowSpinner();
    const form = ref(null);

    const isFromReview =
      ctx.root.$router.currentRoute.query.fromReview !== undefined;

    const pages = filterPages(WorkDetailsDefinition.pages).filter((i) => {
      if (i.onlyOnActivating) return isActivating.value;

      return true;
    });

    async function incrementPage() {
      showError.value = false;
      const valid = await form.value[0].validate();
      if (!valid) {
        if (pages[0].showWorkplaceSearch) {
          const { chosenWorkplace } = useWorkplaceSearch();
          if (!chosenWorkplace.workplaceId) {
            showError.value = true;
          }
        }
        return;
      }
      const page = pages[props.currentPage];
      setShowSpinner(true);
      const result = await page.completionAction(page.fields);
      setShowSpinner(false);
      if (!result.success) {
        showNotification("error", result.message);
        return;
      }

      showError.value = false;

      nextStep(ctx.root.$router);
    }

    function mapAnswersToCurrentPage() {
      const thisPage = pages[props.currentPage];
      if (thisPage) {
        thisPage.fields.forEach((field) => {
          Object.keys(memberDetails).map(function(key) {
            if (key === field.key) {
              field.value = memberDetails[key].value;
            }
          });
        });
      }
    }

    const goBack = () => goToPreviousPage(ctx.root.$router);

    watch(
      () => props.currentPage,
      () => {
        mapAnswersToCurrentPage();
      },
    );

    mapAnswersToCurrentPage();

    return {
      form,
      pages,
      incrementPage,
      showError,
      goBack,
      isFromReview,
      studentCodes,
    };
  },
};
</script>

<style lang="scss" scoped></style>
